import { useRecipeDeleteQueries } from "./useRecipeDeleteQueries"

export const useRecipeDelete = ({resetDeleteInfo }) =>
{
    const {mutateDeleteRecipe} = useRecipeDeleteQueries({resetDeleteInfo });
    return {mutateDeleteRecipe};
}